import React from "react";
import "./blog.css";

import { Article } from "../../components";

import imgBlog1 from "../../assets/blog01.png";
import imgBlog2 from "../../assets/blog02.png";
import imgBlog3 from "../../assets/blog03.png";
import imgBlog4 from "../../assets/blog04.png";
import imgBlog5 from "../../assets/blog05.png";

const Blog = () => {
  return (
    <div className="gpt3__blogContainer">
      <div className="gpt3__blogContainerA">
        <Article
          date="Sep 26, 2021"
          title="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          type="main"
          image={imgBlog1}
        />
      </div>
      <div className="gpt3__blogContainerB">
        <Article
          date="Sep 26, 2021"
          title="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          type="normal"
          image={imgBlog2}
        />
        <Article
          date="Sep 26, 2021"
          title="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          type="normal"
          image={imgBlog3}
        />
        <Article
          date="Sep 26, 2021"
          title="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          type="normal"
          image={imgBlog4}
        />
        <Article
          date="Sep 26, 2021"
          title="GPT-3 and Open  AI is the future. Let us exlore how it is?"
          type="normal"
          image={imgBlog5}
        />
      </div>
    </div>
  );
};

export default Blog;
